import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { SkipStep } from '../../SkipStep';

import { AIDescriptionLoader } from './AIDescriptionLoader';

export function AIDescriptionWrapper(): React.JSX.Element {
	const { data } = useStepState();

	if (data.petition?.aiPromptChoice !== 'ai') return <SkipStep />;

	// when including the ai_asks_choice step, we want to skip this step if the user has selected an ask
	// the fallback option is for them to write their own
	const hasAiAsksChoices = data.petition.aiAsksChoice?.options && data.petition.aiAsksChoice.options.length > 0;
	if (hasAiAsksChoices && data.petition.aiAsksChoice?.selectedAsk !== 'fallback') return <SkipStep />;

	return <AIDescriptionLoader />;
}
